<template>
    <swiper-container
        :pagination="{
            clickable: true
        }"
        :navigation="isHoverSlider"
        @mouseover="isHoverSlider = true"
        @mouseleave="isHoverSlider = false"
    >
        <news-slider-slide
            v-for="(image, index) in sliderImg"
            :key="index"
            :img="image"
        />
    </swiper-container>
</template>

<script>
import NewsSliderSlide from '@/components/news/NewsSliderSlide.vue'

export default {
    name: 'NewsSlider',
    components: { NewsSliderSlide },
    props: {
        sliderImg: Array
    },
    data() {
        return {
            isHoverSlider: false
        }
    }
}
</script>
